export function getUseFeedChoiceKey(jazelId: string | null | undefined): string {
  const id = String(jazelId || '').trim()
  return `ise:onboarding:useFeed:${id || 'unknown'}`
}

export function parseUseFeedChoice(raw: string | null | undefined): boolean | null {
  if (raw === '1') return true
  if (raw === '0') return false
  return null
}

